"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotteryScheduleButton = exports.LOTTERY_SCHEDULE_DIALOG_KEY = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const provider_api_firebase_1 = require("@dzambalaorg/provider-api-firebase");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const utils_1 = require("../../../../../utils");
const dialog_1 = require("./dialog");
exports.LOTTERY_SCHEDULE_DIALOG_KEY = "lotterySchedule";
const LotteryScheduleButton = (props) => {
    const { className, contract, contract: { id, parameters }, disabled, onRefreshPage, variant, } = props;
    const { openFormDialog, formDialogUniqueKey, mode } = (0, react_hooks_1.useDialogForm)();
    const api = (0, provider_api_firebase_1.useApi)();
    const handleSchedule = () => {
        openFormDialog(`${exports.LOTTERY_SCHEDULE_DIALOG_KEY}.${id}`, void 0, "button");
    };
    const handleScheduleConfirm = async ({ data }) => {
        await api
            .fetchJson({
            url: `/lottery/contracts/${id}/schedule`,
            method: "POST",
            data,
        })
            .then(async () => {
            await onRefreshPage();
        });
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleSchedule, icon: icons_material_1.ManageHistory, message: "form.buttons.schedule", className: className, dataTestId: "LotteryScheduleButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract) || process.env.BUSINESS_TYPE === types_1.BusinessType.B2B, variant: variant }), (0, jsx_runtime_1.jsx)(dialog_1.LotteryScheduleDialog, { onExternalConfirm: handleScheduleConfirm, open: formDialogUniqueKey === `${exports.LOTTERY_SCHEDULE_DIALOG_KEY}.${id}.${mode}`, initialValues: {
                    schedule: parameters.schedule,
                } })] }));
};
exports.LotteryScheduleButton = LotteryScheduleButton;
//# sourceMappingURL=index.js.map